<template>
   <div class="bg-light pt-3 pt-lg-5 pb-5">
      <b-container fluid>
         <b-row>

            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>

            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">

               <b-row>
                  <b-col cols="12" lg="8">
                     <h5>Validação de Autenticidade</h5>
                     <hr>
                     <p>
                        Na Pedale os anfitriões são independentes, e eles precisam de informações para que eles possam alugar suas bicicletas com mais segurança. É nessa seção que nós validamos a sua autenticidade, ou seja, nós sabemos que você, é você mesmo ;)
                     </p>

                     <p>
                        <strong>Fique tranquilo</strong>, nós não compartilharemos seus documentos com o anfitrião, ele verá apenas o <strong class="text-primary">Cartão Perfil do Ciclista</strong>.
                     </p>

                     <p>
                        Dica: Usuários Ouro são aqueles que transmitem mais segurança para o Anfitrião.
                     </p>

                     <b-col cols="12" lg="4">
                        <UserVerificationCard
                           userType="usuário"
                           v-if="isMobile"
                           :refetch="refetch"
                           showBtnBikes
                           :userId="this.user._id"
                        />
                     </b-col>

                     <!-- Verificação Redes Sociais -->

                     <socialForm :social-data="user.social"></socialForm>


                     <!-- Verificação Pessoal -->
                     <el-card class="box-card dashboard-card mt-4">

                        <div slot="header">
                           <strong>Verificação pessoal</strong>
                        </div>

                        <div v-if="this.userData">
                           <VerifyPhone
                              :number="this.userData.additionalInformation.phone"
                              :countryCod="this.userData.additionalInformation.countryCod"
                              :verifiedPhone="this.userData.additionalInformation.verifiedPhone"
                              :userId="this.userData._id"
                              :btnVerifyInLine="false"
                              :readonly="true"
                           >
                           </VerifyPhone>
                        </div>

                     </el-card>

                     <!-- Verificação de Documentos -->
                     <el-card class="box-card dashboard-card mt-4">

                        <div slot="header">
                           <strong>Verificação de documentos</strong>
                        </div>

                        <div v-if="this.userData">
                           <VerifyDoc :userId="this.userData._id" ></VerifyDoc>
                        </div>

                     </el-card>
                  </b-col>

                  <b-col cols="12" lg="4" v-if="this.user._id">
                     <UserVerificationCard
                        userType="usuário"
                        :refetch="refetch"
                        :userId="this.user._id"
                        v-if="!isMobile" />
                  </b-col>

               </b-row>

            </b-col>
         </b-row>
      </b-container>

   </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
import UserVerificationCard from "@/components/UserVerificationCardV2";
import VerifyPhone from "@/components/VerifyPhone";
import VerifyDoc from "@/components/VerifyDoc";
import SocialForm from "@/views/dashboard/account/profile/components/social";
import UserService from "@/services/user.service";

export default {
   name: 'Verificacoes',
   components: {
      DashUserNav,
      SocialForm,
      VerifyPhone,
      VerifyDoc,
      UserVerificationCard
   },
   data() {
      return {
         loading: {
            dataUser: false
         },
         user: {},
         isMobile: false,
         refetch: false,
      }
   },
   beforeDestroy () {
      if (typeof window !== 'undefined') {
         window.removeEventListener('resize', this.onResize, { passive: true })
      }
   },
   async mounted() {

      if (!this.userData._id) await this.getUser();
      this.user = this.userData

      if (!this.currentUser) {
         this.$router.push('/login')
      }

      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })

   },
   methods: {

      //Obtem os dados do usuário.
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },

      onResize () {
         this.isMobile = window.innerWidth < 992
      }

   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user.data
      }
   },
   watch: {
      userData: function (e) {
         if (e) {
            this.refetch = true;
            setTimeout(() => {
               this.refetch = false
            }, 1000)
         }
      }
   }
}
</script>

<style scoped>

</style>
